/**
 * 400~600 에러도 throw 합니다.
 * @param url
 * @throws FailedToFetchError
 */
export async function fetchStrictly(
  input: RequestInfo,
  init?: RequestInit
): Promise<Response> {
  const response = await fetch(input, init);
  if (response.ok) {
    return response;
  } else {
    const status = response.status;
    const errorText = await response.text();
    throw new Error(
      `in fetchStrictly : [${status}], request : ${JSON.stringify(
        input
      )}, errorJson: ${errorText}`
    );
  }
}
